import {slideToggle} from './slides-toggle';
const body = document.querySelector('body');

document.querySelector('.hamburger').addEventListener('click', function(event) {
	event.preventDefault();
	if(document.querySelector('body').classList.contains('show-nav')) {
		body.classList.remove('show-nav');
		body.classList.add('hide-nav');
		setTimeout(function() {
			body.classList.remove('hide-nav');
		}, 500);
	} else {
		body.classList.remove('hide-nav');
		body.classList.add('show-nav');
	}
	return false;
});

let submenuToggle = document.querySelectorAll('.submenu-toggle');
submenuToggle.forEach(toggle => {
	toggle.addEventListener('mouseup', function(event) {
		event.preventDefault();
		event.stopPropagation();

		let submenu = this.parentNode.parentNode.querySelector('.sub-menu');
		slideToggle(submenu, 250);

		this.classList.toggle('open');
	});
});